import React, { Component } from "react";
import Card from "react-bootstrap/Card";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
class EmployeeCard extends Component {
  state = {};
  render() {
    return (
      /* <Card className="bg-primary" style={{ width: "15rem" }}>
        <Card.Img
          roundedCircle
          className="bg-primary"
          variant="top"
          src={this.props.employeeVal.imgUrl}
        />
        <Card.Body>
          <Card.Title>{this.props.employeeVal.title}</Card.Title>
          <Card.Text className="text-info">
            {this.props.employeeVal.text}
          </Card.Text>
          <Button variant="primary">Go somewhere</Button>
        </Card.Body>
      </Card>*/

      <div className=" text-center  mb-5 mt-5" style={{ maxWidth: " 18rem" }}>
        <Image
          roundedCircle
          className="card-img-top"
          width="10px"
          src={this.props.employeeVal.imgUrl}
          alt="Card image"
        ></Image>
        <div className="card-body text-info">
          <h5 className="card-title"> {this.props.employeeVal.title}</h5>
          <p className="card-text">{this.props.employeeVal.text}</p>
          <a href={this.props.employeeVal.instagramUrl} target="_blank">
            <img
              src="\images\Instagram_2.png"
              width="30"
              height="30"
              roundedCircle
              // className="d-inline-block "
              alt=""
              style={{ margin: "0px" }}
            ></img>
          </a>{" "}
        </div>
      </div>
    );
  }
}

export default EmployeeCard;
